"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    PRACTICE_STANDARDIZED_TEST: {
        SAT: 'Practice SAT',
        ACT: 'Practice ACT',
    },
    OFFICIAL_STANDARDIZED_TEST: {
        SAT: 'Official SAT',
        ACT: 'Official ACT',
    },
    ENGLISH: {
        TOEFL_IBT: 'TOEFL iBT',
        TOEFL_PBT: 'TOEFL PBT',
        IELTS: 'IELTS',
        Duolingo: 'Duolingo',
    },
    CORE_ACADEMICS: {
        A_LEVELS: 'A-Levels',
        IB: 'Predicted IB',
        ATAR: 'Predicted ATAR',
        GPA: 'GPA',
        NCEA: 'NCEA',
    },
    CLASS_RANK: 'Decile Rank',
};
//# sourceMappingURL=automatedGoalTypes.js.map